<div class="row mb-3" *ngIf="simulation.status == 2">
  <div class="col">
    <div class="d-flex justify-content-center align-items-center" style="height: 38px;">
      <div class="alert alert-primary" role="alert">
        <h6 class="mb-0">
          Downloading climate data...
        </h6>
      </div>
    </div>
  </div>
</div>

<div class="row mb-3" *ngIf="simulation.status == 3">
  <div class="col">
    <div class="d-flex justify-content-between align-items-center">
      <div>
        <div class="form-check form-check-inline">
          <input class="form-check-input" type="radio" name="observation" value="daily" [(ngModel)]="simulation.dataMode" (ngModelChange)="changeDataMode($event)">
          <label class=" form-check-label" for="daily">Daily observations</label>
        </div>
        <div class="form-check form-check-inline">
          <input class="form-check-input" type="radio" name="observation" value="accumulated" [(ngModel)]="simulation.dataMode" (ngModelChange)="changeDataMode($event)">
          <label class=" form-check-label" for="accumulation">Season accumulation</label>
        </div>
        <div class="form-check form-check-inline">
          <input class="form-check-input" type="radio" name="observation" value="ewe" [(ngModel)]="simulation.dataMode" (ngModelChange)="changeDataMode($event)">
          <label class=" form-check-label" for="ewe">Probability of extreme events</label>
        </div>
      </div>

      <div class="form-inline mb-0">
        <label for="compareYear">Compare with:</label>
        <select class="form-control ml-3" name="compareYear" [(ngModel)]="simulation.compareYear" (ngModelChange)="changeCompareYear($event)">
          <option *ngFor="let year of compareYears" [value]="year">{{year}}</option>
        </select>
      </div>

    </div>
  </div>
</div>

<ng-container *ngIf="chartReady && simulation.dataMode == 'daily'">
  <div (mousemove)="synchronizeTooltips($event)" (mouseleave)="hideTooltips($event)">
    <div class="card mb-3">
      <div class="card-body pt-2 pb-0">
        <highcharts-chart class="chart" [Highcharts]="Highcharts" [options]="charts[1].options" (chartInstance)="onChartLoaded($event, 'totR')"></highcharts-chart>
      </div>
    </div>

    <div class="card mb-3">
      <div class="card-body pt-2 pb-0">
        <highcharts-chart class="chart" [Highcharts]="Highcharts" [options]="charts[2].options" (chartInstance)="onChartLoaded($event, 'arid')"></highcharts-chart>
      </div>
    </div>

    <div class="card mb-3">
      <div class="card-body pt-2 pb-0">
        <highcharts-chart class="chart" [Highcharts]="Highcharts" [options]="charts[0].options" (chartInstance)="onChartLoaded($event, 'avgT')"></highcharts-chart>
      </div>
    </div>

  </div>
</ng-container>

<ng-container *ngIf="chartReady && simulation.dataMode == 'accumulated'">
  <div (mousemove)="synchronizeTooltips($event)" (mouseleave)="hideTooltips($event)">
    <div class="card mb-3">
      <div class="card-body pt-2 pb-0">
        <highcharts-chart class="chart" [Highcharts]="Highcharts" [options]="chartsAcc[0].options" (chartInstance)="onChartLoaded($event, 'totR')"></highcharts-chart>
      </div>
    </div>

    <div class="card mb-3">
      <div class="card-body pt-2 pb-0">
        <highcharts-chart class="chart" [Highcharts]="Highcharts" [options]="chartsAcc[1].options" (chartInstance)="onChartLoaded($event, 'arid')"></highcharts-chart>
      </div>
    </div>

  </div>
</ng-container>

<ng-container *ngIf="chartReady && simulation.dataMode == 'ewe'">
  <div (mousemove)="synchronizeTooltips($event)" (mouseleave)="hideTooltips($event)">

    <div class="card mb-3">
      <div class="card-body pt-2 pb-0">
        <highcharts-chart class="chart" [Highcharts]="Highcharts" [options]="charts[3].options" (chartInstance)="onChartLoaded($event, 'ewe')"></highcharts-chart>
      </div>
    </div>

  </div>
</ng-container>
